import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import './index.css';

export const HEADER_ID = 'HEADER_ID';

const headerPropTypes = {
  title: PropTypes.node.isRequired,
  links: PropTypes.array,
  subheader: PropTypes.func,
  isDark: PropTypes.bool,
};

const headerDefaultProps = {
  subheader: null,
  isDark: false,
  links: [],
};

class Header extends Component {
  renderSubheader = () => {
    const Subheader = this.props.subheader;

    if (Subheader) {
      return (
        <div className="Header__subheader">
          <div className="u__container u__full_height">
            <div className="Header__subheader_row">
              <Subheader />
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  renderLinks = () => {
    const { links } = this.props;
    const linksIntoHeaderMenuItems = link => {
      return (
        <li key={link.to}>
          <Link
            to={link.to}
            className={classNames('Header__menu_item u__normalize_anchor', {
              'Header__menu_item--active': link.isActive,
            })}
          >
            {link.label}
          </Link>
        </li>
      );
    };

    return links.map(linksIntoHeaderMenuItems);
  };

  render() {
    const { isDark, title } = this.props;
    const headerClass = classNames('Header', { 'Header--dark': isDark });

    return (
      <div id={HEADER_ID}>
        <div className={headerClass}>
          <div className="u__container u__full_height">
            <div className="Header__row">
              <strong className="Header__title">{title || 'Revendedor Chama'}</strong>
            </div>
          </div>
        </div>

        {this.renderSubheader()}
      </div>
    );
  }
}

Header.propTypes = headerPropTypes;
Header.defaultProps = headerDefaultProps;

export default Header;



// WEBPACK FOOTER //
// ../ui-components/components/Header/index.jsx